import React from 'react';
import currency from 'currency.js';
export const messageMaker = (type) => {
  switch (type) {
    case 'nc':
      return {
        message: (
          <div>
            <strong>Producto con nota de crédito: </strong> Pedido en reembolso,
            el plazo de éste está sujeto al medio de pago que usaste.
          </div>
        ),
        terms: (
          <div>
            Más información en nuestros{' '}
            <a
              href="https://simple.ripley.com.pe/minisitios/especial/servicio-al-cliente/terminos-condiciones"
              target="_blank"
              rel="noreferrer"
            >
              Términos y condiciones.
            </a>
          </div>
        ),
        severity: 'success',
      };
    case 'returned':
      return {
        message: (
          <div>
            <strong>Producto con extorno: </strong> Pedido en reembolso, el
            plazo de éste está sujeto al medio de pago que usaste. Más
            información en nuestros{' '}
            <a
              href="https://simple.ripley.com.pe/minisitios/especial/servicio-al-cliente/terminos-condiciones"
              target="_blank"
              rel="noreferrer"
            >
              Términos y condiciones.
            </a>
          </div>
        ),
        severity: 'success',
      };
    case 'reserved':
      return {
        message: (
          <div>
            <strong>Producto reservado: </strong> Recuerda que debes realizar el
            pago para que tu pedido se procese. Puedes revisar los lugares de{' '}
            <a
              href="https://home.ripley.com.pe/Terminos/pagoefectivo.pdf"
              target="_blank"
              rel="noreferrer"
            >
              pago aquí.
            </a>
          </div>
        ),
        severity: 'alert',
      };
    case 'failed':
      return {
        message: (
          <div>
            <strong>Tuvimos un inconveniente con tu pedido: </strong>Estamos
            tramitando tu reembolso, lamentamos el inconveniente y agradecemos
            tu preferencia.
          </div>
        ),
        severity: 'alert',
      };
    default:
      return;
  }
};

export const priceFormatter = (totalPrice, symbol = '$') => {
  return currency(totalPrice, {
    separator: '.',
    decimal: ',',
    precision: 0,
    symbol,
  }).format();
};
